import React, {useEffect, useState} from 'react';
import Header from "../../components/navigation/Header";
import {useNavigate, useSearchParams} from "react-router-dom";
import {activateTestAgreement, getTestAgreementInfo} from "../../services/ProductRepository";
import {useError} from "../../hooks/useError";

export function ActivateProductAgreement() {

    const [testAgreement, setTestAgreement] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const {setErrorMessage} = useError();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    useEffect(() => {
        if (token != null && token !== "") {
            getTestAgreementInfo(token).then(response => {
                setTestAgreement(response)
            }).catch(error => console.log(error));
        }
    }, []);

    if (testAgreement == null) {
        return <div></div>
    }

    return (
        <div>
            <Header/>
            <div className={"container"}>
                <div className={" d-flex flex-column p-3 my-3 "}>
                    <h3>Test abonnement</h3>
                    <p>Denne linken gir deg automatisk tilgang på en test-versjon av
                        <strong
                            className={"text-decoration-underline"}> {testAgreement.productName}</strong>.
                        Linken blir ugyldig etter bruk.
                    </p>
                    <h5>Dette får du tilgang på:</h5>
                    {
                        testAgreement.features.map(feature => (
                            <p>{feature}</p>
                        ))
                    }
                    <p>Test abonnementet er gyldig til: <strong>{testAgreement.validTo}</strong></p>
                    <button className={"btn btn-dark text-white"} onClick={() => activateTestAgreement(token, setErrorMessage).then(() => navigate("/"))}>Aktiver</button>
                </div>
            </div>
        </div>
    );

}